module.exports = __webpack_public_path__ + "static/media/settings.c54b74ce.svg";